<template>
  <div class="grid gap-8 lg:grid-cols-[auto_320px] xl:grid-cols-[auto_360px]">
    <slot />
  </div>
</template>
